import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EntryPoint, EntryPointService, UserService } from '@mirage-projects/cw-commons';
import { Acls, CatalogObjectTypes, PermAccessLevelString, UserResponseData } from '@mirage-projects/cw-models';

@Injectable({
    providedIn: 'root',
})
export class AppUserService implements UserService {
    constructor(
        private http: HttpClient,
        private entryPointService: EntryPointService
    ) {}

    /**
     * Get the user by id
     * @param id User id
     */
    get(id: string): Observable<UserResponseData> {
        const entryPoint = this.entryPointService.getResource(EntryPoint.USERS, id);
        return this.http.get<UserResponseData>(`${entryPoint}`, {}).pipe(catchError((err) => throwError(err)));
    }

    /**
     * Get the list of users
     */
    getAll(): Observable<UserResponseData[]> {
        const entryPoint = this.entryPointService.getResource(EntryPoint.USERS);
        return this.http.get<UserResponseData[]>(`${entryPoint}`, {}).pipe(catchError((err) => throwError(err)));
    }

    /**
     * Add user permission
     */
    addUserPermission(
        userId: string,
        objectId: number,
        objectType: CatalogObjectTypes,
        objEffect: PermAccessLevelString
    ): Observable<void> {
        const entryPoint = `${this.entryPointService.getResource(EntryPoint.PERMISSIONS)}user/${userId}`;
        const perm = {
            id: objectId,
            type: objectType,
            effect: objEffect,
        };
        return this.http.post<void>(`${entryPoint}`, perm).pipe(catchError((err) => throwError(err)));
    }

    /**
     * Delete user permission
     */
    deleteUserPermission(userId: string, objectId: number, objectType: CatalogObjectTypes): Observable<void> {
        const entryPoint = `${this.entryPointService.getResource(EntryPoint.PERMISSIONS)}user/${userId}`;
        const perm = {
            id: objectId,
            type: objectType,
        };
        return this.http.delete<void>(`${entryPoint}`, { body: perm }).pipe(catchError((err) => throwError(err)));
    }

    /**
     * Add user Acl
     */
    addUserAcl(userId: string, acl: Acls): Observable<void> {
        const entryPoint = `${this.entryPointService.getResource(EntryPoint.ACL_USERS)}${userId}`;
        return this.http.post<void>(`${entryPoint}`, acl);
    }

    /**
     * Delete user Acl
     */
    deleteUserAcl(userId: string, aclId: string): Observable<void> {
        const entryPoint = `${this.entryPointService.getResource(EntryPoint.ACL_USERS)}${userId}/${aclId}`;
        return this.http.delete<void>(`${entryPoint}`);
    }
}
